const PREFIX = 'zx-studio-recovery:';
const MAX_AGE = 24 * 60 * 60 * 1000;

function key(user) {
  if (!user || user.id == null) return '';
  return PREFIX + JSON.stringify([String(user.id), String(user.currentOrgId || '')]);
}

export function readStudioRecovery(storage, user) {
  const name = key(user);
  if (!storage || !name) return null;
  try {
    const value = JSON.parse(storage.getItem(name) || 'null');
    if (!value) return null;
    if (value.version !== 1 || !value.savedAt || Date.now() - value.savedAt > MAX_AGE) {
      storage.removeItem(name); return null;
    }
    return value;
  } catch (_) { return null; }
}

export function writeStudioRecovery(storage, user, baseline, payload) {
  const name = key(user);
  if (!storage || !name) return false;
  try {
    const value = JSON.stringify({ version: 1, savedAt: Date.now(), baseline, payload });
    if (value.length > 524288) return false;
    storage.setItem(name, value); return true;
  } catch (_) { return false; }
}

export function clearStudioRecovery(storage, user) {
  try { const name = key(user); if (storage && name) storage.removeItem(name); } catch (_) { /* Optional recovery storage. */ }
}

export function clearAllStudioRecoveries(storage) {
  if (!storage) return;
  try {
    const keys = [];
    for (let index = 0; index < storage.length; index++) keys.push(storage.key(index));
    keys.filter(name => name && name.startsWith(PREFIX)).forEach(name => storage.removeItem(name));
  } catch (_) { /* Logout must remain available. */ }
}

function luminance(value) {
  if (!/^#[0-9a-f]{6}$/i.test(String(value || ''))) return null;
  const rgb = [1, 3, 5].map(index => parseInt(value.slice(index, index + 2), 16) / 255)
    .map(channel => channel <= 0.04045 ? channel / 12.92 : ((channel + 0.055) / 1.055) ** 2.4);
  return rgb[0] * 0.2126 + rgb[1] * 0.7152 + rgb[2] * 0.0722;
}

export function themeContrastWarnings(theme = {}) {
  return [[theme.title, theme.background, '标题与页面背景'], ['#FFFFFF', theme.primary, '白色按钮文字与品牌主色']]
    .map(([foreground, background, label]) => {
      const a = luminance(foreground), b = luminance(background);
      if (a == null || b == null) return null;
      const ratio = (Math.max(a, b) + 0.05) / (Math.min(a, b) + 0.05);
      return ratio < 4.5 ? `${label}对比度为 ${ratio.toFixed(2)}，建议达到 4.5` : null;
    }).filter(Boolean);
}
